import React from 'react'
import pandit from "../../assets/images/new/fav-removebg-preview.png";
import shape2 from "../../assets/images/shapes/service-bg-shape-2-rtl.png";
import { t } from 'i18next';

const HowItWorks = ({ serviceData }) => {
    return (
        <>
            <section className="service-one" data-aos="fade-up"
                data-aos-duration="1000" style={{ padding: "30px 0" }}>
                <div

                    className="service-one__shape-two"
                    style={{ backgroundImage: `url(${shape2})` }}
                ></div>
                <div
                    className="container"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <div className="row">
                        <div className="col-12">
                            <div
                                className="section-title text-center"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <h6 className="sec-title__tagline bw-split-in-right">
                                    <img className=" tagline-img" src={pandit} alt="" />
                                    {t("How It Works")}{" "}
                                </h6>

                                <h3 className="sec-title__title bw-split-in-left">
                                    {serviceData.howItWorksMainHeading}
                                </h3>
                            </div>
                            <div
                                class="row gutter-y-30 d-flex align-center justify-center"
                                style={{ gap: "20px", justifyContent: 'center' }}
                            >
                                {serviceData.howItWorks?.map((item, index) => (
                                    <div
                                        className="col-lg-3 col-md-6 wow fadeInUp"
                                        data-wow-delay="00ms"
                                    >
                                        <div
                                            className="service-one__item text-center d-flex flex-column h-100"
                                        // style={{ color: "#a42642" }}
                                        >
                                            <div className="service-one__item__icon">
                                                <img src={pandit} alt="careox" height={50} width={50} />
                                            </div>
                                            <h3
                                                className="service-one__item__title"
                                                style={{ textAlign: "center" }}
                                            >
                                                {item?.howItWorksTitle}
                                            </h3>
                                            <p
                                                className="service-one__item__text flex-grow-1"

                                                style={{
                                                    textAlign: "left",
                                                    whiteSpace: "normal",
                                                    wordBreak: "break-word",
                                                    hyphens: "auto",
                                                    lineHeight: "1.6",
                                                    fontFamily: "Bricolage Grotesque"
                                                }}
                                            >
                                                {item?.howItWorksDesc}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default HowItWorks
